<template>
  <div>
    <div style="">
      <h2 v-if="isEdit&&preId" style="text-align: center">修改预案</h2>
      <h2 v-if="isEdit===false&&preId===undefined" style="text-align: center">添加预案</h2>
      <Divider></Divider>
      <div style="width: 80%;margin: 0 auto">
        <Form :label-width="100" ref="planRefs" :model="preDataFrom" :rules="preDataRules">
          <Row>
            <Col :span="24">
              <FormItem label="预案名称" prop="planName">
                <Input v-model="preDataFrom.planName"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :span="12">
              <FormItem label="预案类型" prop="planType">
                <Select v-model="preDataFrom.planType" style="width: 80%">
                  <Option v-for="(item,index) in preplanTypeList" :key="index" :value="item.id"
                          :label="item.name"></Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="预案类别" prop="planCategory">
                <Select v-model="preDataFrom.planCategory" style="width: 80%">
                  <Option v-for="(item,index) in preplanCategoryList" :key="index" :value="item.id"
                          :label="item.name"></Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <!--        <Row>-->
          <!--          <Col :span="12">-->
          <!--            <FormItem label="添加人">-->
          <!--              <Input v-model="preDataFrom.createUser" style="width: 80%"></Input>-->
          <!--            </FormItem>-->
          <!--          </Col>-->
          <!--          <Col :span="12">-->
          <!--            <FormItem label="添加部门">-->
          <!--              <Input v-model="preDataFrom.createDept" style="width: 80%"></Input>-->
          <!--            </FormItem>-->
          <!--          </Col>-->
          <!--        </Row>-->
          <!--          <Row>-->
          <!--            <Col :span="12">-->
          <!--              <FormItem label="是否现场指挥">-->
          <!--                <el-switch v-model="preDataFrom.isLive" style="width: 80%"></el-switch>-->
          <!--              </FormItem>-->
          <!--            </Col>-->
          <!--            <Col :span="12">-->
          <!--              <FormItem label="行政区域">-->
          <!--                <Row>-->
          <!--                  <Col :span="10">-->
          <!--                    <Select v-model="preDataFrom.street" @on-change="getAreaByStreetId">-->
          <!--                      <Option v-for="(item,index) in streetsList" :key="index" :value="item.id"-->
          <!--                              :label="item.name"></Option>-->
          <!--                    </Select>-->
          <!--                  </Col>-->
          <!--                  <Col :span="10" offset="2">-->
          <!--                    <Select v-model="preDataFrom.area">-->
          <!--                      <Option v-for="(item,index) in AreaList" :key="index" :value="item.id"-->
          <!--                              :label="item.name"></Option>-->
          <!--                    </Select>-->
          <!--                  </Col>-->
          <!--                </Row>-->
          <!--              </FormItem>-->
          <!--            </Col>-->
          <!--          </Row>-->
          <Row>
            <Col :span="24">
              <FormItem label="预案附件">
                <Upload
                  ref="upload"
                  :headers="attachmentHeaders"
                  :show-upload-list="false"
                  :on-success="attachmentSuccess"
                  :before-upload="attachmentBeforeUpload"
                  :action="$uploadUrl+'/api/file/upload'"
                >
                  <Button icon="ios-cloud-upload-outline" :loading="uploading">上传附件</Button>
                </Upload>
                <!--                {{preDataFrom}}-->
                <div v-if="isEdit">
                <span>{{
                    preDataFrom.planFilePath === '' ? '' : preDataFrom.planFilePath.split('1433223')[0]
                  }}</span>
                  <Icon style="margin-left: 100px" v-if="preDataFrom.planFilePath!==''" type="md-close"
                        @click="delPlanFilePath"/>
                </div>
                <div v-else>
                  {{ preDataFrom.planFilePath.split('1433223')[0] }}
                </div>
                <!--                {{preDataFrom}}-->
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :span="8" offset="8">
              <FormItem>
                <Button v-if="preId" type="primary" @click="editPrePlan"
                        :loading="editLoaing">修改
                </Button>
                <Button v-else type="primary" @click="savePrePlan"
                        :loading="savePrePlanLoading">保存
                </Button>
                <Button style="margin-left: 20px" @click="cancelPlan" type="error">取消</Button>
                <Button style="margin-left: 20px" @click="back">返回</Button>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddPrePlan",
  data() {
    return {
      preId: '',
      isEdit: false,
      uploading: false,
      savePrePlanLoading: false,
      editLoaing: false,
      attachmentHeaders: {Authorization: localStorage.getItem('token')},
      preplanCategoryList: [],// 预案类别
      preplanTypeList: [],// 预案类型
      preDataFrom: {
        planName: '',// 预案名称
        planType: '',// 预案类型
        planCategory: '',// 预案类别
        street: '',
        area: '',
        administrativeDivision: '', // 行政区域
        createUser: '',// 添加人
        createDept: '',// 添加部门
        isLive: false,// 是否现场指挥
        planFilePath: '',// 预案附件
      },
      preDataRules: {},
      streetsList: [],
      AreaList: []
    }
  },
  mounted() {
    this.preId = this.$route.query.preId;
    this.isEdit = this.$route.query.isEdit !== undefined;
    console.log(this.preId)
    console.log(this.isEdit)
    this.getPreplanCategoryList();
    this.getPreplanTypeList();
    this.getStreets()
    if (this.preId) {
      this.getPrePlanInfo();
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    // 获取预案信息
    getPrePlanInfo() {
      this.$http.get(`/api/planManagements/${this.preId}`).then(res => {
        if (res.status === 200) {
          console.log(res.data)
          this.preDataFrom = res.data
          this.preDataFrom.street = res.data.administrativeDivision.split('_')[0]
          this.preDataFrom.area = res.data.administrativeDivision.split('_')[1]
          this.getAreaByStreetId()
        }
      })
    },
    // 获取预案类别
    getPreplanCategoryList() {
      this.$http.get(`/api/planCategorys`).then(res => {
        if (res.status === 200) {
          this.preplanCategoryList = res.data.data
        }
      })
    },
    // 获取预案类型
    getPreplanTypeList() {
      this.$http.get(`/api/planTypes`).then(res => {
        if (res.status === 200) {
          this.preplanTypeList = res.data.data
        }
      })
    },
    // 获取区县
    getStreets() {
      this.$http.get(`/api/street/streets`).then(res => {
        if (res.status === 200) {
          console.log(res)
          this.streetsList = res.data.data
        }
      })
    },
    getAreaByStreetId() {
      this.$http.get(`/api/street/${this.preDataFrom.street}`).then(res => {
        if (res.status === 200) {
          this.AreaList = res.data.data
        }
      })
    },
    attachmentSuccess(response, file, fileList) {
      console.log(response, file, fileList)
      this.preDataFrom.planFilePath = file.name + '1433223' + response
      this.uploading = false
    },
    attachmentBeforeUpload() {
      this.uploading = true
    },
    delPlanFilePath() {
      this.preDataFrom.planFilePath = ''
    },
    savePrePlan() {
      this.$refs.planRefs.validate((valid) => {
        if (valid) {
          this.savePrePlanLoading = true
          let requestData = {
            ...this.preDataFrom,
            administrativeDivision: this.preDataFrom.street + '_' + this.preDataFrom.area,
            planFilePath: this.preDataFrom.planFilePath
          }
          console.log(requestData)
          this.$http.post(`/api/planManagements`, requestData).then(res => {
            if (res.status === 201) {
              this.$Message.success('保存成功')
              this.$router.push({name: 'PreliminaryPlans'})
              this.savePrePlanLoading = false
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editPrePlan() {
      this.$refs.planRefs.validate((valid) => {
        if (valid) {
          this.editLoaing = true
          let requestData = {
            id: this.preId,
            ...this.preDataFrom,
            administrativeDivision: this.preDataFrom.street + '_' + this.preDataFrom.area,
            planFilePath: this.preDataFrom.planFilePath
          }
          this.$http.put(`/api/planManagements`, requestData).then(res => {
            if (res.status === 200) {
              this.$Message.success('修改成功')
              this.$router.push({name: 'PreliminaryPlans'})
              this.editLoaing = false
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelPlan() {
      this.$refs.planRefs.resetFields()
      this.$refs.upload.clearFiles()
    }
  }
}
</script>

<style scoped>

</style>
